
import React from 'react';
import { Button } from '@/components/ui/button';
import { Loader2 } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

interface FormActionsProps {
  isLoading: boolean;
  isEditMode: boolean;
}

const FormActions: React.FC<FormActionsProps> = ({ isLoading, isEditMode }) => {
  const navigate = useNavigate();

  return (
    <div className="flex justify-end space-x-2">
      <Button 
        type="button" 
        variant="outline" 
        onClick={() => navigate('/farms')}
      >
        Cancel
      </Button>
      <Button 
        type="submit" 
        disabled={isLoading}
      >
        {isLoading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
        {isEditMode ? 'Update Farm' : 'Create Farm'}
      </Button>
    </div>
  );
};

export default FormActions;
